import { createSelector } from '@ngrx/store';
import { ISummaryData } from '@partners/api';
import { IRootState } from '../../../root';
import { ISummaryState } from './summary.state';

export class SummarySelectors {
  // todo: replace any type state with root state (once defined)
  static readonly summaryState = (state: IRootState): ISummaryState => {
    return state.summary as ISummaryState;
  };

  static readonly model = createSelector(SummarySelectors.summaryState, (summary: ISummaryState) => {
    return summary.model;
  });

  static readonly data = createSelector(SummarySelectors.summaryState, (summary: ISummaryState) => {
    return summary.data;
  });

  static readonly loanData = createSelector(SummarySelectors.data, (data: ISummaryData) => {
    return data?.loanData;
  });
}
